const RETURN_URL_KEY = 'returnUrl';
const RETURN_URL_CREATED_AT_KEY = 'returnUrlCreatedAt';
const RETURN_URL_MAX_AGE = 30 * 60 * 1000;
const AUTH_PATHS = new Set([
  '/login',
  '/logout',
  '/verifyadfs',
  '/redirect-to-app',
]);

export function normalizeReturnUrl(location) {
  const value =
    typeof location === 'string'
      ? location
      : location?.pathname && `${location.pathname}${location.search || ''}`;
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null;

  try {
    const url = new URL(value, window.location.origin);
    if (
      url.origin !== window.location.origin ||
      AUTH_PATHS.has(url.pathname.toLowerCase())
    )
      return null;
    return `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
}

export function readReturnUrl() {
  try {
    if (!isReturnUrlFresh(sessionStorage.getItem(RETURN_URL_CREATED_AT_KEY)))
      return null;
    return normalizeReturnUrl(sessionStorage.getItem(RETURN_URL_KEY));
  } catch {
    return null;
  }
}

export function isReturnUrlFresh(createdAt) {
  const age = Date.now() - Number(createdAt);
  return (
    createdAt != null &&
    Number.isFinite(age) &&
    age >= 0 &&
    age < RETURN_URL_MAX_AGE
  );
}

export function saveReturnUrl(location) {
  const url = normalizeReturnUrl(location);
  const createdAt = Date.now();
  try {
    if (url) {
      sessionStorage.setItem(RETURN_URL_KEY, url);
      sessionStorage.setItem(RETURN_URL_CREATED_AT_KEY, String(createdAt));
    } else {
      clearReturnUrl();
    }
  } catch {
    return createdAt;
  }
  return createdAt;
}

export function clearReturnUrl() {
  try {
    sessionStorage.removeItem(RETURN_URL_KEY);
    sessionStorage.removeItem(RETURN_URL_CREATED_AT_KEY);
  } catch {
    return;
  }
}
